<template>
  <div class="seomain">
    <ul class="tab-tilte">
      <li
        v-for="(title, index) in tabTitle"
        @click="
          changeActiveIndex(index);
          get_st_list(index);
        "
        :class="{ active: cur == index }"
        class="text-center"
        :key="index"
      >
        <span>{{ title }}</span>
      </li>
      <div class="cl"></div>
    </ul>
    <!-- 搜索  单行 -->
    <!-- <div class="keyword">
      <van-search
        v-model="order_code"
        shape="round"
        show-action
        background="#e0e0e0"
        placeholder="请输入订单号搜索"
        @search="onSearch"
        @cancel="onCancel"
      />
    </div> -->

    <!-- 搜索 多行 -->
    <div class="keyword">
      <van-form @submit="submitKeyword">
        <van-field v-model="order_code" label="单号" placeholder="请输入单号" />
        <van-field v-model="sku" label="SKU" placeholder="SKU" />
        <div :style="{ padding: '16px', backgroundColor: '#fff' }">
          <van-button round block type="info" native-type="submit">搜 索</van-button>
        </div>
      </van-form>
    </div>
    <div class="tab-content tab-content-list">
      <div v-show="cur == 0" class="st-list-box pan-0">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist0" :key="v.id" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.code }}</div>
              <div class="t-status">待出库</div>
            </div>
            <div class="st-list-main">
              <p>调拨批次：{{ v.batch }}</p>
              <p>调出仓库：{{ v.warehouse_out_name }}</p>
              <p>调入仓库：{{ v.warehouse_in_name }}</p>
              <p>经办人：{{ v.operatorname }}</p>
              <p>
                联系电话：<a :href="'tel:' + v.operatorphone">{{ v.operatorphone }}</a>
              </p>
            </div>
            <div class="st-list-bottom">
              <router-link :to="'/transfero/info/' + v.id" class="st-opt-btn">出 库</router-link>
            </div>
          </div>
        </van-list>
      </div>
      <div v-show="cur == 1" class="st-list-box pan-1">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist1" :key="v.id" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.code }}</div>
              <div class="t-status">调拨在途</div>
            </div>
            <div class="st-list-main">
              <p>调拨批次：{{ v.batch }}</p>
              <p>调出仓库：{{ v.warehouse_out_name }}</p>
              <p>调入仓库：{{ v.warehouse_in_name }}</p>
              <p>经办人：{{ v.operatorname }}</p>
              <p>
                联系电话：<a :href="'tel:' + v.operatorphone">{{ v.operatorphone }}</a>
              </p>
              <p>物流公司：{{ v.purchasingtracking }}</p>
              <p @click="getExInfo(v.id)">物流单号：{{ v.logisticsnumber }}</p>
              <p>物流状态：{{ v.logistics_status }}</p>
            </div>
            <div class="st-list-bottom">
              <router-link :to="'/transfero/info/' + v.id" class="st-opt-btn">查 看</router-link>
            </div>
          </div>
        </van-list>
      </div>
      <div v-show="cur == 2" class="st-list-box pan-2">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list" v-for="(v, k) in stlist2" :key="v.id" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.code }}</div>
              <div class="t-status">已入库</div>
            </div>
            <div class="st-list-main">
              <p>调拨批次：{{ v.batch }}</p>
              <p>调出仓库：{{ v.warehouse_out_name }}</p>
              <p>调入仓库：{{ v.warehouse_in_name }}</p>
              <p>经办人：{{ v.operatorname }}</p>
              <p>
                联系电话：<a :href="'tel:' + v.operatorphone">{{ v.operatorphone }}</a>
              </p>
              <p>物流公司：{{ v.purchasingtracking }}</p>
              <p @click="getExInfo(v.id)">物流单号：{{ v.logisticsnumber }}</p>
              <p>物流状态：{{ v.logistics_status }}</p>
            </div>
            <div class="st-list-bottom">
              <router-link :to="'/transfero/info/' + v.id" class="st-opt-btn">查 看</router-link>
            </div>
          </div>
        </van-list>
      </div>
    </div>

    <van-dialog class="exDialog" ref="exDialog" v-model="exShow" :title="exDialogTitle">
      <van-steps direction="vertical" :active="0" active-color="#fa6e09">
        <van-step v-for="(item, index) in exDataList" :key="index">
          <h3>{{ item.time }}</h3>
          <p>{{ item.step }}</p>
        </van-step>
      </van-steps>
    </van-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      loading: false,
      finished: false,
      page: 1,
      tabTitle: ["待出库", "调拨在途", "已入库"],
      cur: 0,
      status: 0,
      stlist0: [],
      stlist1: [],
      stlist2: [],
      exShow: false,
      exDialogTitle: "",
      exDataList: [],
      order_code: "", // 关键字搜索
      sku: "",
    };
  },
  watch: {},
  computed: {},
  methods: {
    async get_st_list(e) {
      this.stlist0 = [];
      this.stlist1 = [];
      this.stlist2 = [];
      this.page = 1;
      this.loading = true;
      this.finished = false;
      this.onLoad();
    },
    init() {
      let activeIndex = window.sessionStorage.getItem("transfero_activeIndex");
      if (activeIndex) {
        this.cur = activeIndex;
      }
    },
    changeActiveIndex(value) {
      this.cur = value;
      window.sessionStorage.setItem("transfero_activeIndex", value);
    },
    async onLoad() {
      let result = await this.$post(this.$api.stGetDiaobooList, {
        order_code: this.order_code,
        status: this.cur,
        page: this.page,
        sku: this.sku,
      });

      if (result.data.length == 0) return (this.finished = true);
      // 进行操作
      this["stlist" + this.cur].push(...result.data.list);
      // 操作完成
      this.page += 1;
      this.loading = false;
    },
    // 获取物流信息
    async getExInfo(id) {
      let { purchasingtracking, logisticsnumber } = this["stlist" + this.cur].filter((item) => item.id == id)[0];
      this.exDialogTitle = purchasingtracking + ": " + logisticsnumber;
      let result = await this.$post(this.$api.stGetDiaoboExInfo, { id });
      if (result.data.code == 1) {
        console.log(result.data.data);
        this.exDataList = result.data.data;
      } else {
        this.exDataList = [{ step: "暂无轨迹信息,请确认订单号是否填写正确." }];
      }
      this.exShow = true;
    },
    onSearch(val) {
      this["stlist" + this.cur] = [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
    onCancel() {},
    // 关键字搜索
    submitKeyword() {
      this["stlist" + this.cur] = [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
  },
  created() {
    this.init();
    window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "调拨出库" });
    });
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.keyword {
  position: fixed;
  width: 100%;
  top: 50px;
}
/* 2行input start */
.tab-content-list {
  padding-top: 220px;
}
/* 2行input  end */
</style>
